import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardRoute extends Route {
  @service store;
  @service router;
  @service roadmap;

  selectedRoadmap = null;

  async loadRoadmapInitiatives(initiative_ids) {
    const promises = initiative_ids.map((id) =>
      this.store.findRecord('initiative', id, {
        include: 'workstream',
      }),
    );
    await Promise.allSettled(promises);
  }
  async beforeModel() {
    if (!this.roadmap.id) await this.roadmap.setup();
    let roadmap_id = this.roadmap.id;
    let roadmap = this.store.peekRecord('roadmap', roadmap_id);
    if (!roadmap || roadmap?.isDestroyed) await this.roadmap.setup();
    roadmap_id = this.roadmap.id;
    roadmap = this.store.peekRecord('roadmap', roadmap_id);
    this.selectedRoadmap = roadmap;
    const initiative_ids = roadmap.hasMany('initiatives').ids();
    await this.loadRoadmapInitiatives(initiative_ids);
    await this.store.findAll('role');
    return roadmap;
  }

  async model() {
    return this.selectedRoadmap;
  }
}

export default instrumentRoutePerformance(PlanningDashboardRoute);
